import constants from "../constants";

const { UPDATE_CHAT_STORE, ADD_CHAT_MESSAGE_STORE } = constants;

const initialState = {
  messagesByClientReservation: {},
  apartmentsMetaByClientReservation: {},
};

export default (state = initialState, action) => {
  if (!action) return state;
  const { type } = action;

  switch (type) {
    case UPDATE_CHAT_STORE: {
      const { messagesByClientReservation = {}, apartmentsMetaByClientReservation = {} } =
        action.data || {};
      const shouldReplace = Boolean(action?.data?.replace);

      const mergedMessagesByClientReservation = {
        ...(shouldReplace ? {} : state.messagesByClientReservation),
      };

      Object.entries(messagesByClientReservation).forEach(([clientReservationId, messages]) => {
        mergedMessagesByClientReservation[clientReservationId] = {
          ...(state.messagesByClientReservation?.[clientReservationId] || {}),
          ...(messages || {}),
        };
      });

      const mergedApartmentsMetaByClientReservation = {
        ...(shouldReplace ? {} : state.apartmentsMetaByClientReservation),
      };

      Object.entries(apartmentsMetaByClientReservation).forEach(([clientReservationId, meta]) => {
        mergedApartmentsMetaByClientReservation[clientReservationId] = {
          ...(state.apartmentsMetaByClientReservation?.[clientReservationId] || {}),
          ...(meta || {}),
          lastRead: {
            ...(state.apartmentsMetaByClientReservation?.[clientReservationId]?.lastRead || {}),
            ...(meta?.lastRead || {}),
          },
        };
      });

      return {
        ...state,
        messagesByClientReservation: mergedMessagesByClientReservation,
        apartmentsMetaByClientReservation: mergedApartmentsMetaByClientReservation,
      };
    }

    case ADD_CHAT_MESSAGE_STORE: {
      const { clientReservationId, message } = action.data || {};
      if (!clientReservationId || !message?.id) return state;

      const prev = state.messagesByClientReservation?.[clientReservationId] || {};
      const prevMeta = state.apartmentsMetaByClientReservation?.[clientReservationId] || {};

      const prevLastMessageAt = Number(prevMeta?.lastMessage?.createdAt || 0);
      const nextMessageAt = Number(message?.createdAt || 0);
      const shouldUpdateLastMessage = nextMessageAt >= prevLastMessageAt;

      const nextMeta = shouldUpdateLastMessage
        ? {
            ...prevMeta,
            previousMessage: prevMeta?.lastMessage || null,
            lastMessage: {
              text: message?.text || "",
              createdAt: nextMessageAt,
              sender: message?.sender,
              deleted: Boolean(message?.deleted),
            },
            updatedAt: message?.updatedAt,
          }
        : prevMeta;

      return {
        ...state,
        messagesByClientReservation: {
          ...state.messagesByClientReservation,
          [clientReservationId]: {
            ...prev,
            [message.id]: message,
          },
        },
        apartmentsMetaByClientReservation: {
          ...state.apartmentsMetaByClientReservation,
          [clientReservationId]: nextMeta,
        },
      };
    }

    default:
      return state;
  }
};
